module.exports = __webpack_public_path__ + "static/media/fondo_comediante.2a267a5a.jpg";